import {useEffect} from 'react'
import Loader from '../../custom/loader/Loader'
import {useAuth} from 'app/modules/auth/core/Auth'
import {useNavigate} from 'react-router-dom'
import LecturerDashboard from 'app/modules/dua/Lecturer/LecturerDashboard'
import StudentDashboard from 'app/modules/dua/Student-Portal/StudentDashboard'
import SchoolLecturerDashboard from 'app/modules/dphs/Lecturer/SchoolLecturerDashboard'
import SchoolStudentDashboard from 'app/modules/dphs/Student-Portal/SchoolStudentDashboard'

const DashboardWrapper = () => {
  const {currentUser} = useAuth()
  const navigate = useNavigate()

  const pos = currentUser?.position
  const sys = localStorage.getItem('system')

  const isSpecialRole =
    pos === 'Lecturer' || pos === 'Student' || pos === 'School Lecturer' || pos === 'School Student'

  useEffect(() => {
    if (!currentUser || !sys) return

    if (!isSpecialRole && sys === 'System') navigate('/system-mgt/home')
    else if (!isSpecialRole && sys === 'University') navigate('/dua/home')
    else if (!isSpecialRole && sys === 'School') navigate('/dphs/home')
    else if (!isSpecialRole && sys === 'Canteen') navigate('/canteen/home')
  }, [currentUser, sys, navigate, isSpecialRole])

  if (pos === 'Lecturer') return <LecturerDashboard />
  if (pos === 'School Lecturer') return <SchoolLecturerDashboard />
  if (pos === 'Student') return <StudentDashboard />
  if (pos === 'School Student') return <SchoolStudentDashboard />

  return <Loader />
}

export {DashboardWrapper}
